/**
 * Region design intelligence — broad regional visual expectations.
 * Keyed by region slug. Additive, pure data.
 */

export const REGION_KNOWLEDGE = Object.freeze({
  'north-america': { asOf: '2026', confidence: 0.62, compositionDirection: ['bold-direct-layouts'], typographyDirection: ['confident-sans'] },
  europe: { asOf: '2026', confidence: 0.62, compositionDirection: ['editorial-restraint'], typographyDirection: ['refined-grotesque-or-serif'] },
  'middle-east': { asOf: '2026', confidence: 0.62, compositionDirection: ['rtl-aware'], typographyDirection: ['elegant-arabic-aware-type'], colorPsychology: ['gold-and-deep-tones-read-premium'] },
  'south-asia': { asOf: '2026', confidence: 0.6, colorPsychology: ['vibrant-saturated-color-is-celebratory'], visualTrends: ['rich-ornamentation'] },
  'east-asia': { asOf: '2026', confidence: 0.6, compositionDirection: ['dense-information-friendly'], colorPsychology: ['red-and-gold-signal-fortune'] },
});
